import { type Store } from 'redux';

import config, { isEnabled } from 'Config';
import Analytics from 'Lib/analytics';
import initBugsnag from 'Lib/analytics/bugsnag';
import {
  createLogger as createConfigServiceLogger,
  initializeInstance as initializeConfigService,
} from 'Lib/ConfigService';
import type { Action, GlobalStateType } from 'Lib/reduxType';
import Services from 'Services';

import { apiHelperInitiated } from 'Store/app/actions';
import LocationTracker from 'Store/location/logic';

import SparksService from 'Store/sparks/SparksService';

// NOTE: this is specific to the main app - if you need to initialize a service
// on the static site as well, ensure logic is added to its initializeStoreServices function.
export async function initializeStoreServices(store: Store<GlobalStateType, Action>) {
  const { getState, dispatch } = store;
  await initializeConfigService(createConfigServiceLogger());

  Services.init(getState, dispatch, () => dispatch(apiHelperInitiated()));
  SparksService.init(store);

  if (isEnabled('enableAnalytics')) {
    Analytics.init(config);
    LocationTracker.init(store);
  } else {
    window.gtag = undefined;
  }
  // HACK: decouple Bugsnag from Analytics.init since it's used for static sites which do not support levers
  initBugsnag(config);
}

export { initializeInstance, getInstance, setInstance } from './singleton';
